interface PingWatchdogOptions {
  checkIntervalMs: number;
  timeoutMs: number;
  onTimeout: () => void;
}

/**
 * Сервер периодически шлёт ping (см. WEBSOCKET_PROTOCOL.md). Если ping не
 * приходит дольше timeoutMs, соединение считается зомби (сокет мог
 * "зависнуть" без close-события, например при тихом обрыве на прокси/NAT) —
 * вызывающий код должен сам разорвать сокет, чтобы запустить реконнект.
 */
export class PingWatchdog {
  private lastPingAt: number | null = null;
  private interval: ReturnType<typeof setInterval> | null = null;

  constructor(private readonly options: PingWatchdogOptions) {}

  start(): void {
    this.stop();
    this.lastPingAt = Date.now();
    this.interval = setInterval(
      () => this.check(),
      this.options.checkIntervalMs,
    );
  }

  stop(): void {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    this.lastPingAt = null;
  }

  /** Вызывать при получении ping от сервера. */
  notifyPing(): void {
    this.lastPingAt = Date.now();
  }

  private check(): void {
    if (this.lastPingAt === null) return;
    if (Date.now() - this.lastPingAt > this.options.timeoutMs) {
      this.options.onTimeout();
    }
  }
}
